import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgHomeIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M11.985 4 4 11.975 6.531 12v8h3.673v-4.895h3.562v4.893h3.673V12H20l-8.015-8Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgHomeIcon);
const Memo = memo(ForwardRef);
export default Memo;
